import React, { createContext, useState,useContext } from "react";

import {weatherApi} from "../api/index";


const MyContext = createContext(null);


export const useWeather = ()=>{
 return useContext(MyContext);
}





const ContextProvider = (props) => {
  const [data, setData] = useState(null);
  const [input, setInput] = useState("");

  const fetchData =async ()=>{
    const response =await weatherApi(input);
    setData(response);
}

  return (
    <MyContext.Provider value={{data,input,setData,setInput,fetchData}} >
      {props.children}
    </MyContext.Provider>
  );
};

export { ContextProvider, MyContext };
